package gr.tech.pdfgenerator.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import gr.tech.pdfgenerator.infrastructure.data.GeneratorData
import gr.tech.pdfgenerator.util.INPUTS
import org.jetbrains.compose.web.css.px

@Composable
fun generalInputsSection() {
    var generalInputState by GeneratorData.generalInputsState

    Row(
        modifier = Modifier
            .padding(bottom = 12.px)
            .gap(16.px)
            .width(600.px)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            StringInputLabel(
                label = "Company Name",
                id = INPUTS.GENERAL.customerNameInput,
                initialValue = generalInputState.companyName
            ) {
                generalInputState = generalInputState.copy(companyName = it)
            }

            StringInputLabel(
                label = "Company State",
                id = INPUTS.GENERAL.companyStateInput,
                initialValue = generalInputState.companyState
            ) {
                generalInputState = generalInputState.copy(companyState = it)
            }

            StringInputLabel(
                label = "Company Address",
                id = INPUTS.GENERAL.companyAddressInput,
                initialValue = generalInputState.companyAddress
            ) {
                generalInputState = generalInputState.copy(companyAddress = it)
            }

            StringInputLabel(
                label = "Company City",
                id = INPUTS.GENERAL.companyCityInput,
                initialValue = generalInputState.companyCity
            ) {
                generalInputState = generalInputState.copy(companyCity = it)
            }

            StringInputLabel(
                label = "Company Zip",
                id = INPUTS.GENERAL.companyZipInput,
                initialValue = generalInputState.companyZip
            ) {
                generalInputState = generalInputState.copy(companyZip = it)
            }
        }

        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            StringInputLabel(
                label = "Company Representative",
                id = INPUTS.GENERAL.companyRepresentativeInput,
                initialValue = generalInputState.companyRepresentative
            ) {
                generalInputState = generalInputState.copy(companyRepresentative = it)
            }

            StringInputLabel(
                label = "Facility Address",
                id = INPUTS.GENERAL.facilityAddressInput,
                initialValue = generalInputState.facilityAddress
            ) {
                generalInputState = generalInputState.copy(facilityAddress = it)
            }

            StringInputLabel(
                label = "Utility",
                id = INPUTS.GENERAL.companyUtilityInput,
                initialValue = generalInputState.companyUtility
            ) {
                generalInputState = generalInputState.copy(companyUtility = it)
            }

            StringInputLabel(
                label = "Start Date",
                id = INPUTS.GENERAL.effectiveDateInput,
                initialValue = generalInputState.effectiveDate
            ) {
                generalInputState = generalInputState.copy(effectiveDate = it)
            }

            StringInputLabel(
                label = "End Date",
                id = INPUTS.GENERAL.documentExpInput,
                initialValue = generalInputState.expirationDate
            ) {
                generalInputState = generalInputState.copy(expirationDate = it)
            }
        }
    }
}


